// extracted by mini-css-extract-plugin
export default {"usage":"usage_usage__ln1Vo","info":"usage_info__kTitx"};